import { useMemo } from 'react';
import { useQueryClient } from '@common-fe/common-fe';
import _ from 'lodash';

import { Option } from '@/common/types';
import { PlanByPlanYearDto } from '@/modules/HealthPlan/HealthPlan.types.ts';
import { useHealthPlanNameStore } from '@/modules/HealthPlan/HealthPlanSetup/BasicProperties/HealthPlanName/stores';
import { PLANS_BY_PLAN_YEAR_QUERY_KEY } from '@/modules/HealthPlan/queries/usePlansByPlanYear.query';

const useLinkedPlanOptions = (): Option[] => {
  const queryClient = useQueryClient();
  const planYearId = useHealthPlanNameStore((state) => state.state.planYearId);
  const linkedPlanIds = useHealthPlanNameStore((state) => state.state.plans);

  return useMemo(() => {
    const cachedData = queryClient.getQueryData<{ data: PlanByPlanYearDto[] }>([
      PLANS_BY_PLAN_YEAR_QUERY_KEY,
      planYearId,
    ]);
    const allPlans = cachedData?.data || [];
    return allPlans
      .filter((plan) => linkedPlanIds?.includes(_.toString(plan.id)))
      .map((plan) => ({ key: _.toString(plan.id), value: plan.name, title: plan.name }));
  }, [queryClient, planYearId, linkedPlanIds]);
};

export default useLinkedPlanOptions;
